module.exports = __webpack_public_path__ + "img/62ffd6f.jpg";